import { IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

type TChatHeaderUserCardButton = {
  onClick: () => void;
};

export const ChatHeaderUserCardButton: React.VFC<TChatHeaderUserCardButton> = ({ onClick }) => {
  return (
    <a className={styles['arrow']} data-testid="ChatHeaderUserCardButton">
      <IconActionChevronRight12 onClick={onClick} color="gray60_100" />
    </a>
  );
};
